var _defs, _title, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogoBlanc = function SvgLogoBlanc(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "afa24600-5128-4b37-ac63-2e2bd136f812",
    "data-name": "Calque 1",
    viewBox: "0 0 147.1076 84.402223",
    width: 147.1076,
    height: 84.402222,
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".beb1a74d-8f67-41cc-94ab-ddca4946d2e0{fill:#fff;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "title6"
  }, "logo-blanc-footer")) : title ? /*#__PURE__*/React.createElement("title", {
    id: "title6"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 56.307608,59.602224 a 17.76,17.76 0 0 1 8.9,2.2 v -2.9 c 0,-4.3 -3,-6.9 -7.9,-6.9 a 21.59,21.59 0 0 0 -10.4,2.9 l -3,-5.4 a 26.82,26.82 0 0 1 14.2,-4.3 c 11.1,0 14.9,6 14.9,14.2 v 24.1 h -6.8 l -0.6,-1.7 c -2,1.5 -4.9,2.6 -9.6,2.6 -7.9,0 -14.1,-4.9 -14.1,-12.4 0,-7.3 5.8,-12.4 14.4,-12.4 z m 1.3,18.6 c 4.6,0 7.9,-2.6 7.9,-6.4 0,-3.8 -3.2,-6.4 -7.9,-6.4 -4.7,0 -7.9,2.7 -7.9,6.4 0,3.7 3.2,6.4 7.9,6.4 z",
    id: "path8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 19.707608,45.202224 c 11.5,0 19.8,8.4 19.8,19.6 0,11.2 -8.4,19.6 -19.8,19.6 -11.4,0 -19.69999996,-8.2 -19.69999996,-19.5 a 19.25,19.25 0 0 1 19.69999996,-19.7 z m 0,32.3 c 6.9,0 12,-5.4 12,-12.7 0,-7.3 -5.1,-12.7 -12,-12.7 -6.9,0 -11.9,5.4 -11.9,12.7 0,7.3 5,12.7 11.9,12.7 z",
    id: "path10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 81.707608,73.102224 a 10.18,10.18 0 0 0 8.9,4.9 c 3.3,0 5.7,-1.6 5.7,-4.7 0,-7.2 -18.2,-4.6 -18.2,-17.5 0,-6.6 5.6,-10.6 12.8,-10.6 a 13.33,13.33 0 0 1 12.200002,6.9 l -5.400002,3.6 a 8.11,8.11 0 0 0 -7.2,-4.1 c -2.9,0 -5,1.5 -5,4.1 0,7.2 18.200002,4.1 18.200002,17.3 0,6.9 -5.900002,11.4 -13.500002,11.4 -7.6,0 -11.6,-4.1 -13.4,-7.4 z",
    id: "path12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 112.00761,32.002224 a 4.84,4.84 0 0 1 4.9,4.9 4.9,4.9 0 1 1 -9.8,0 4.84,4.84 0 0 1 4.9,-4.9 z m -3.9,14.1 h 7.8 v 37.3 h -7.8 z",
    id: "path14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 125.10761,73.102224 a 10.18,10.18 0 0 0 8.9,4.9 c 3.3,0 5.7,-1.6 5.7,-4.7 0,-7.2 -18.2,-4.6 -18.2,-17.5 0,-6.6 5.6,-10.6 12.8,-10.6 a 13.33,13.33 0 0 1 12.2,6.9 l -5.4,3.6 a 8.11,8.11 0 0 0 -7.2,-4.1 c -2.9,0 -5,1.5 -5,4.1 0,7.2 18.2,4.1 18.2,17.3 0,6.9 -5.9,11.4 -13.5,11.4 -7.6,0 -11.6,-4.1 -13.4,-7.4 z",
    id: "path16"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    x: 0.007608036,
    y: 28.102226,
    width: 79.099998,
    height: 5.5,
    id: "rect18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "M 0.00760804,8.5022235 A 8.31,8.31 0 0 1 8.507608,0.00222352 a 8.15,8.15 0 0 1 4.9,1.49999998 l -0.9,2.9 a 6.94,6.94 0 0 0 -3.9,-1.3 5.07,5.07 0 0 0 -5.1,5.4 5.07,5.07 0 0 0 5.1,5.4000005 7.91,7.91 0 0 0 4.1,-1.3 l 0.9,2.9 a 8.45,8.45 0 0 1 -5,1.5 8.16,8.16 0 0 1 -8.59999996,-8.5000005 z",
    id: "path20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 14.807608,8.5022235 a 8.5,8.5 0 1 1 8.5,8.5000005 8.25,8.25 0 0 1 -8.5,-8.5000005 z m 3.5,0 a 5.07,5.07 0 0 0 5.1,5.4000005 5.13,5.13 0 0 0 5.1,-5.4000005 5.07,5.07 0 0 0 -5.1,-5.4 5.19,5.19 0 0 0 -5.1,5.4 z",
    id: "path22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 33.207608,8.5022235 a 8.5,8.5 0 1 1 8.5,8.5000005 8.25,8.25 0 0 1 -8.5,-8.5000005 z m 3.5,0 a 5.11,5.11 0 1 0 10.2,0 5.07,5.07 0 0 0 -5.1,-5.4 5.13,5.13 0 0 0 -5.1,5.4 z",
    id: "path24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 52.507608,0.40222352 h 5.2 c 3.2,0 5.4,1.99999998 5.4,5.09999998 a 5.13,5.13 0 0 1 -5.3,5.2000005 h -1.9 v 6.1 h -3.4 z m 4.7,7.39999998 a 2.23,2.23 0 0 0 2.4,-2.3 2.16,2.16 0 0 0 -2.4,-2.2 h -1.5 v 4.6 h 1.5 z",
    id: "path26"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 65.107608,0.40222352 h 8.4 V 3.4022235 h -5.1 v 3.6 h 4.4 v 2.9 h -4.4 v 3.9000005 h 5.3 v 2.9 h -8.6 z",
    id: "path28"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 76.407608,0.40222352 h 4.9 c 3.6,0 5.5,2.19999998 5.5,4.89999998 a 4.69,4.69 0 0 1 -2.5,4.3 l 3.9,7.2000005 h -3.6 l -3.2,-6.4 h -1.8 v 6.4 h -3.3 V 0.40222352 Z m 4.8,7.09999998 a 2,2 0 0 0 2.2,-2.2 c 0,-1.3 -0.9,-2.1 -2.4,-2.1 h -1.4 v 4.3 z",
    id: "path30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 93.407608,12.502224 -1.4,4.2 h -3.3 l 5.8,-16.30000048 h 3.5 L 103.80761,16.702224 h -3.3 l -1.400002,-4.2 z m 2.7,-8.6000005 -1.9,5.9 h 3.8 z",
    id: "path32"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 106.80761,3.3022235 h -3.8 V 0.30222352 h 10.9 V 3.3022235 h -3.8 V 16.702224 h -3.3 z",
    id: "path34"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 115.90761,0.40222352 h 3.3 V 16.702224 h -3.3 z",
    id: "path36"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 126.90761,16.702224 -6,-16.30000048 h 3.6 l 4.2,12.50000048 4.2,-12.50000048 h 3.6 l -6,16.30000048 z",
    id: "path38"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "beb1a74d-8f67-41cc-94ab-ddca4946d2e0",
    d: "m 138.20761,0.40222352 h 8.4 V 3.4022235 h -5.1 v 3.6 h 4.4 v 2.9 h -4.4 v 3.9000005 h 5.3 v 2.9 h -8.6 z",
    id: "path40"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoBlanc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-blanc.371c989b.svg";
export { ForwardRef as ReactComponent };